import { render } from "./CourseLoader.vue?vue&type=template&id=0759b471&scoped=true&lang=true"
import script from "./CourseLoader.vue?vue&type=script&lang=js"
export * from "./CourseLoader.vue?vue&type=script&lang=js"

import "./CourseLoader.vue?vue&type=style&index=0&id=0759b471&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0759b471"]])

export default __exports__